/**
 * 색을 제외한 모든 스케일. 웹·네이티브가 같은 숫자를 쓴다(단위는 각 플랫폼에서 붙인다 — 웹은 px, RN은 무단위).
 */

/** 4pt 그리드. 임의 여백 금지 — 반드시 이 키 중 하나를 쓴다 */
export const space = {
  0: 0,
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 20,
  6: 24,
  8: 32,
  10: 40,
  12: 48,
  16: 64,
  20: 80,
} as const

/** 토스 문법 — 라운드가 크다: 버튼·필드 md(14), 카드 lg(20), 큰 시트 xl(24) */
export const radius = {
  none: 0,
  sm: 8,
  md: 14,
  lg: 20,
  xl: 24,
  full: 9999,
} as const

export const borderWidth = {
  hairline: 1,
  thick: 2,
} as const

export const fontSize = {
  xs: 12,
  sm: 14,
  md: 16,
  lg: 18,
  xl: 22,
  '2xl': 28,
  '3xl': 34,
  '4xl': 44,
} as const

/** fontSize와 키를 1:1로 맞춘 행간 — 짝을 깨지 말 것 */
export const lineHeight = {
  xs: 16,
  sm: 20,
  md: 24,
  lg: 28,
  xl: 30,
  '2xl': 36,
  '3xl': 42,
  '4xl': 52,
} as const

export const fontWeight = {
  regular: '400',
  medium: '500',
  semibold: '600',
  bold: '700',
} as const

export const letterSpacing = {
  tight: -0.4,
  normal: 0,
  wide: 0.6,
} as const

/** ms */
export const duration = {
  instant: 0,
  fast: 120,
  normal: 200,
  slow: 320,
} as const

/** CSS cubic-bezier 문자열. RN에서는 Easing.bezier(...)로 같은 값을 쓴다 */
export const easing = {
  standard: 'cubic-bezier(0.2, 0, 0, 1)',
  decelerate: 'cubic-bezier(0, 0, 0, 1)',
  accelerate: 'cubic-bezier(0.3, 0, 1, 1)',
} as const

export const opacity = {
  disabled: 0.4,
  pressed: 0.7,
  muted: 0.64,
} as const

/** 웹 전용 — 반응형 분기점(px) */
export const breakpoint = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
} as const

export const zIndex = {
  base: 0,
  raised: 10,
  overlay: 100,
  modal: 200,
  toast: 300,
} as const

export type Space = keyof typeof space
export type Radius = keyof typeof radius
export type FontSize = keyof typeof fontSize
export type FontWeight = keyof typeof fontWeight
export type Duration = keyof typeof duration
